import { render, staticRenderFns } from "./UpdatePatientDeviceAndProucts.vue?vue&type=template&id=97a4dafc&"
import script from "./UpdatePatientDeviceAndProucts.vue?vue&type=script&lang=js&"
export * from "./UpdatePatientDeviceAndProucts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports